import { TDevice } from '@cian/utils';
import { TAnalyticsSiteType } from '../../types/analytics';

const DEVICE_TYPE_MAP: { [key: string]: TAnalyticsSiteType } = {
  phone: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};

export const getAnalyticsSiteType = (deviceType: TDevice | undefined): TAnalyticsSiteType => {
  if (deviceType) {
    return DEVICE_TYPE_MAP[deviceType] || 'desktop';
  }

  return 'desktop';
};
